export default "__VITE_ASSET__Kyc_kG3u__"